module.exports = __webpack_public_path__ + "img/pay_paypal.e0abdccc.png";